import React, { Component } from 'react';
import s from './index.module.scss'
import { http } from "../../../common/request";
import { Spin, message } from 'antd'
import { CopyFilled, CheckCircleFilled } from '@ant-design/icons'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import i18next from 'i18next'

class PermissionApply extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requesting: false,
      AppKey: '',
      AppSecret: '',
      copying: '',
      copied: false
    };
  }

  componentDidMount () {
    this.getNewSetting()
  }

  //获取最新setting
  async getNewSetting() {
    this.setState({
      requesting: true
    })
    const res = await http('get', '/account/settings').catch(err => {
      
      this.setState({
        requesting: false
      })

    })
    if (res.data && res.data.code === 0) {

      if (!res.data.data.AppKey || !res.data.data.AppSecret) {
        this.setState({
          requesting: false
        })
        return
      }

      this.setState({
        requesting: false,
        AppKey: res.data.data.AppKey,
        AppSecret: res.data.data.AppSecret
      })

    } else {

      this.setState({
        requesting: false
      })
      message.warn(res.data.desc)

    }
  }

  async apply() {

    this.setState({
      requesting: true
    })
    const res = await http('get', '/app/createDefault').catch(err => {
      
      this.setState({
        requesting: false
      })

    })
    if (res.data && res.data.code === 0) {

      this.getNewSetting()

    } else {

      this.setState({
        requesting: false
      })
      message.warn(res.data.desc)

    }
  }

  componentWillUnmount() {
    this.checkTimer && clearTimeout(this.checkTimer)
  }

  handleCopy(item) {
    this.setState({
      copied: true,
      copying: item
    })
    this.checkTimer && clearTimeout(this.checkTimer)
    this.checkTimer = setTimeout(() => {
      this.setState({
        copied: false
      })
    }, 3000)
  }

  render () {
    const { AppKey, AppSecret, requesting, copying, copied } = this.state
    return (
      <div>
        
        {
          requesting ? <Spin />
          : <div>
            <div className={s.title}>{i18next.t('access_information')}</div>

              { AppKey ? (<div>
                <div className={s.setting_title}>App Key</div>
              <div className={s.setting_content}>
                {AppKey}
                {(copying === 'key' && copied) ? <CheckCircleFilled color='#fffff' className={s.icon} /> : <CopyToClipboard text={AppKey} onCopy={() => this.handleCopy('key')}>
                  <CopyFilled color='#fffff' className={s.icon} />
              </CopyToClipboard> }
              </div>
              <div className={s.setting_title}>App Secret</div>
              <div className={s.setting_content}>
                {AppSecret}
                {(copying === 'secret' && copied) ? <CheckCircleFilled color='#fffff' className={s.icon} /> : <CopyToClipboard text={AppSecret} onCopy={() => this.handleCopy('secret')}>
                  <CopyFilled color='#fffff' className={s.icon} />
              </CopyToClipboard> }
              </div>
              </div>) : <button className={s.apply} onClick={() => {this.apply()}}>{i18next.t('apply')} App Key 和 App Secret</button>}

          </div>
        }

      </div>
    );
  }
}

export default PermissionApply;

